import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import DateComponent from '../Elements/DateComponent';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class TpEvaluatorLinkItem {
  constructor(item) {
    // TpEvaluatorLink fields
    this.TpEvaluatorLinkId = item.tpEvaluatorLinkId || 0;
    this.EvaluatorId = item.evaluatorId || 0;
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.ThirdPartySource = item.thirdPartySource || '';
    this.ThirdPartyEvaluatorId = item.thirdPartyEvaluatorId || '';
    this.LastName = item.lastName || '';
    this.FirstName = item.firstName || '';
    this.Name = `${item.firstName || ''} ${item.lastName || ''}`;
    this.Prefix = item.prefix;
    this.Email = item.email || '';
    this.DateOfBirth = item.dateOfBirth;
    this.ThirdPartyStatus = item.thirdPartyStatus;
    this.DeactivationType = item.deactivationType;
    this.AverageRating = item.averageRating;
    this.LastRating = item.lastRating;
    this.SignupDateTimeUtc = item.signupDateTimeUtc;
    this.BecomeInactiveDateTimeUtc = item.becomeInactiveDateTimeUtc;
    this.DeletedOnUtc = item.deletedOnUtc;
    this.CreatedOnUtc = item.createdOnUtc || new Date();
    this.ModifiedOnUtc = item.modifiedOnUtc || new Date();
    this.CreatedBy = item.createdBy || 1;
    this.ModifiedBy = item.modifiedBy || 1;
    this.Status = item.status;
    this.Login = item.login;
    this.IsGigSpotShopper = item.isGigSpotShopper;
    this.LastLoginDateUtc = item.lastLoginDateUtc;

    // TpEvaluatorLinkAddress fields
    this.TpEvaluatorLinkAddressId = item.tpEvaluatorLinkAddressId || 0;
    this.TpEvaluatorLinkAddressAddress = item.tpEvaluatorLinkAddressAddress;
    this.TpEvaluatorLinkAddressCity = item.tpEvaluatorLinkAddressCity;
    this.TpEvaluatorLinkAddressState = item.tpEvaluatorLinkAddressState;
    this.TpEvaluatorLinkAddressCountry = item.tpEvaluatorLinkAddressCountry;
    this.TpEvaluatorLinkAddressZipCode = item.tpEvaluatorLinkAddressZipCode;
    this.TpEvaluatorLinkAddressPhoneMobile = item.tpEvaluatorLinkAddressPhoneMobile;
    this.TpEvaluatorLinkAddressPhoneMain = item.tpEvaluatorLinkAddressPhoneMain;

    // TpEvaluatorLinkExtended fields
    this.TpEvaluatorLinkExtendedId = item.tpEvaluatorLinkExtendedId || 0;
    this.TpEvaluatorLinkExtendedEmailOptOut = item.tpEvaluatorLinkExtendedEmailOptOut;
    this.TpEvaluatorLinkExtendedPrivacyPolicyId = item.tpEvaluatorLinkExtendedPrivacyPolicyId || 0;
    this.TpEvaluatorLinkExtendedPrivacyPolicyAcceptedOnUtc = item.tpEvaluatorLinkExtendedPrivacyPolicyAcceptedOnUtc;
    this.TpEvaluatorLinkExtendedPrivacyPolicyEnactedOnUtc = item.tpEvaluatorLinkExtendedPrivacyPolicyEnactedOnUtc;
    this.TpEvaluatorLinkExtendedEmailVerified = item.tpEvaluatorLinkExtendedEmailVerified;
    this.TpEvaluatorLinkExtendedChinaIdcardNumber = item.tpEvaluatorLinkExtendedChinaIdcardNumber;
    this.TpEvaluatorLinkExtendedAcceptedIcaOnUtc = item.tpEvaluatorLinkExtendedAcceptedIcaOnUtc;
    this.TpEvaluatorLinkExtendedSex = item.tpEvaluatorLinkExtendedSex;
    this.TpEvaluatorLinkExtendedSpokenLanguage = item.tpEvaluatorLinkExtendedSpokenLanguage;
    this.TpEvaluatorLinkExtendedRegBusiness = item.tpEvaluatorLinkExtendedRegBusiness;
    this.TpEvaluatorLinkExtendedBrBusinessClassification = item.tpEvaluatorLinkExtendedBrBusinessClassification;
    this.TpEvaluatorLinkExtendedCitizenship = item.tpEvaluatorLinkExtendedCitizenship;
    this.TpEvaluatorLinkExtendedTextAllow = item.tpEvaluatorLinkExtendedTextAllow;
    this.TpEvaluatorLinkExtendedThirdPartySystemLanguage = item.tpEvaluatorLinkExtendedThirdPartySystemLanguage;

    // TpEvaluatorLinkPaymentInformation fields
    this.TpEvaluatorLinkPaymentInformationId = item.tpEvaluatorLinkPaymentInformationId;
    this.TpEvaluatorLinkPaymentInformationBankAccountHoldersName =
      item.tpEvaluatorLinkPaymentInformationBankAccountHoldersName;
    this.TpEvaluatorLinkPaymentInformationBank = item.tpEvaluatorLinkPaymentInformationBank;
    this.TpEvaluatorLinkPaymentInformationBankAcct = item.tpEvaluatorLinkPaymentInformationBankAcct;
    this.TpEvaluatorLinkPaymentInformationSwiftCode = item.tpEvaluatorLinkPaymentInformationSwiftCode;
    this.TpEvaluatorLinkPaymentInformationIban = item.tpEvaluatorLinkPaymentInformationIban;
    this.TpEvaluatorLinkPaymentInformationBankBranch = item.tpEvaluatorLinkPaymentInformationBankBranch;
    this.TpEvaluatorLinkPaymentInformationBankAddress = item.tpEvaluatorLinkPaymentInformationBankAddress;
    this.TpEvaluatorLinkPaymentInformationBankZip = item.tpEvaluatorLinkPaymentInformationBankZip;
    this.TpEvaluatorLinkPaymentInformationBankCity = item.tpEvaluatorLinkPaymentInformationBankCity;
    this.TpEvaluatorLinkPaymentInformationIfsccode = item.tpEvaluatorLinkPaymentInformationIfsccode;
    this.TpEvaluatorLinkPaymentInformationBankCountry = item.tpEvaluatorLinkPaymentInformationBankCountry;
    this.TpEvaluatorLinkPaymentInformationPaypalAddress = item.tpEvaluatorLinkPaymentInformationPaypalAddress;
    this.TpEvaluatorLinkPaymentInformationClRutNumber = item.tpEvaluatorLinkPaymentInformationClRutNumber;
    this.TpEvaluatorLinkPaymentInformationCnAliPay = item.tpEvaluatorLinkPaymentInformationCnAliPay;
    this.TpEvaluatorLinkPaymentInformationBrBankCode = item.tpEvaluatorLinkPaymentInformationBrBankCode;
    this.TpEvaluatorLinkPaymentInformationBrPis = item.tpEvaluatorLinkPaymentInformationBrPis;
    this.TpEvaluatorLinkPaymentInformationBrCpf = item.tpEvaluatorLinkPaymentInformationBrCpf;
    this.TpEvaluatorLinkPaymentInformationBrAccountType = item.tpEvaluatorLinkPaymentInformationBrAccountType;
    this.TpEvaluatorLinkPaymentInformationWiseEmail = item.tpEvaluatorLinkPaymentInformationWiseEmail;
    this.TpEvaluatorLinkPaymentInformationWiseCurr = item.tpEvaluatorLinkPaymentInformationWiseCurr;
    this.TpEvaluatorLinkPaymentInformationSgPayNow = item.tpEvaluatorLinkPaymentInformationSgPayNow;
    this.TpEvaluatorLinkPaymentInformationBrPix = item.tpEvaluatorLinkPaymentInformationBrPix;
    this.TpEvaluatorLinkPaymentInformationWiseCurrCode = item.tpEvaluatorLinkPaymentInformationWiseCurrCode;
    this.TpEvaluatorLinkPaymentInformationBrBankBranchNum = item.tpEvaluatorLinkPaymentInformationBrBankBranchNum;
    this.TpEvaluatorLinkPaymentInformationBrBankAcctNum = item.tpEvaluatorLinkPaymentInformationBrBankAcctNum;
    this.TpEvaluatorLinkPaymentInformationTransactionMethod = item.tpEvaluatorLinkPaymentInformationTransactionMethod;
    this.TpEvaluatorLinkPaymentInformationPreferredPaymentMethod =
      item.tpEvaluatorLinkPaymentInformationPreferredPaymentMethod;
    this.TpEvaluatorLinkPaymentInformationWiseAccount = item.tpEvaluatorLinkPaymentInformationWiseAccount;
    this.TpEvaluatorLinkPaymentInformationPayoneerEmail = item.tpEvaluatorLinkPaymentInformationPayoneerEmail;
    this.TpEvaluatorLinkPaymentInformationPayeeAddress = item.tpEvaluatorLinkPaymentInformationPayeeAddress;
    this.TpEvaluatorLinkPaymentInformationPaymentInformationReceived =
      item.tpEvaluatorLinkPaymentInformationPaymentInformationReceived;
    this.TpEvaluatorLinkPaymentInformationPaymentInformationChangedOnUtc =
      item.tpEvaluatorLinkPaymentInformationPaymentInformationChangedOnUtc;
    this.TpEvaluatorLinkPaymentInformationSource = item.tpEvaluatorLinkPaymentInformationSource;
  }

  static displayedInList = 'EntityType';

  static NameOfTheIdField() {
    return 'TpEvaluatorLinkId';
  }
  static nameOfTheItemDetailList() {
    return 'TpEvaluator Profiles';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];

  // A true/false value is rendered blank by the detail box unless its field is listed here (CD-5606).
  static BoolFields = [
    'IsGigSpotShopper',
    'TpEvaluatorLinkExtendedEmailOptOut',
    'TpEvaluatorLinkExtendedEmailVerified',
    'TpEvaluatorLinkExtendedTextAllow',
  ];

  // Gigspot is an RMX North America channel; its flag is meaningless on any other source (CD-5606).
  static GigspotThirdPartySource = 'RMX North America';

  static isGigspotFlagHidden(item) {
    return item.ThirdPartySource !== TpEvaluatorLinkItem.GigspotThirdPartySource;
  }

  static FieldsToShowInDataTable() {
    return [
      // {
      //   label: TpEvaluatorItem.getSelectedCellHeader,
      //   orderById: '',
      //   data: TpEvaluatorItem.getSelectedCellContent,
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 10,
      // },
      {
        label: 'Link ID',
        orderById: '',
        data: 'TpEvaluatorLinkId',
        minWidth: 50,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Source',
        orderById: '',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        // Master = a record of the primary profile the tab was opened for, Slave = a record of a profile
        // linked under it (CD-5527). Computed client-side from the row's TpEvaluatorId.
        label: 'Type',
        orderById: '',
        data: TpEvaluatorLinkItem.getTypeText,
        minWidth: 50,
      },
      {
        label: 'Third-Party ID',
        orderById: '',
        data: 'ThirdPartyEvaluatorId',
        minWidth: 50,
      },
      {
        label: 'Last Name',
        data: 'LastName',
        minWidth: 50,
      },
      {
        label: 'First Name',
        data: 'FirstName',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Email',
        data: 'Email',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Status',
        data: 'Status',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Signup Date',
        data: (item) => dateTimeHelper.getFormattedDate(item.SignupDateTimeUtc, '-'),
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: ' ',
        data: TpEvaluatorLinkItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Main',
      tabLabel: 'Third-Party Evaluator Profile',
      icon: 'fa-solid fa-users',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        //---------------Row 1------------------
        {
          name: 'ThirdPartySource',
          label: 'Source',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'Status',
          label: 'Status',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'LastRating',
          label: 'Last Rating',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //---------------Row 2------------------
        {
          name: 'ThirdPartyEvaluatorId',
          label: 'Third-Party ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'ThirdPartyStatus',
          label: 'Third Party Status',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'AverageRating',
          label: 'Average Rating',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //---------------Row 3------------------
        {
          name: 'Prefix',
          label: 'Prefix',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'DeactivationType',
          label: 'Deactivation Type',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'IsGigSpotShopper',
          label: 'Is Gigspot Shopper',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: TpEvaluatorLinkItem.isGigspotFlagHidden,
        },
        //---------------Row 4------------------
        {
          name: 'LastName',
          label: 'Last Name',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.SignupDateTimeUtc} />,
          label: 'Signup Date',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'Login',
          label: 'Login Name',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //---------------Row 5------------------
        {
          name: 'FirstName',
          label: 'First Name',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: '',
          label: '',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TpEvaluatorId',
          label: 'TpEvaluatorId',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //---------------Row 6------------------
        {
          name: 'Email',
          label: 'Email',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'BecomeInactiveDateTimeUtc',
          label: 'Inactive Date',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TpEvaluatorLinkId',
          label: 'Link ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //---------------Row 6------------------
        {
          name: (item) => <DateComponent value={item.DateOfBirth} />,
          label: 'Date of Birth',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'DeletedOnUtc',
          label: 'Deleted On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        //-------------------------------------------
      ],
    },
    {
      tabName: 'Address',
      tabLabel: 'Address',
      icon: 'fa-solid fa-users',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: (item) => item.TpEvaluatorLinkAddressId,
          label: 'TpEvaluatorLinkAddressId',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressAddress,
          label: 'Address',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressCity,
          label: 'City',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressState,
          label: 'Region/State',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressCountry,
          label: 'Country',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressZipCode,
          label: 'Zip Code',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressPhoneMain,
          label: 'Main Phone',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkAddressPhoneMobile,
          label: 'Mobile Phone',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
      ],
    },
    {
      tabName: 'Extended',
      tabLabel: 'Extended',
      icon: 'fa-solid fa-users',
      rolekey: 'Evaulator_tablisttable_EvaluatorGeneralView',
      data: [
        {
          name: (item) => item.TpEvaluatorLinkExtendedId,
          label: 'TpEvaluatorLinkExtendedId',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TpEvaluatorLinkExtendedEmailOptOut',
          label: 'Email Opt-Out',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedPrivacyPolicyId,
          label: 'Privacy Policy ID',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.TpEvaluatorLinkExtendedPrivacyPolicyAcceptedOnUtc} />,
          label: 'Privacy Policy Accepted On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.TpEvaluatorLinkExtendedPrivacyPolicyEnactedOnUtc} />,
          label: 'Privacy Policy Enacted On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TpEvaluatorLinkExtendedEmailVerified',
          label: 'Email Verified',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedChinaIdcardNumber,
          label: 'China ID Card Number',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => <DateComponent value={item.TpEvaluatorLinkExtendedAcceptedIcaOnUtc} />,
          label: 'ICA Accepted On',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedSex,
          label: 'Sex',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedSpokenLanguage,
          label: 'Spoken Language',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedRegBusiness,
          label: 'Registered Business',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedBrBusinessClassification,
          label: 'Business Classification',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedCitizenship,
          label: 'Citizenship',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: 'TpEvaluatorLinkExtendedTextAllow',
          label: 'Text Allow',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkExtendedThirdPartySystemLanguage,
          label: 'Third Party System Language',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
      ],
    },
    {
      tabName: 'Payment Information',
      tabLabel: 'Payment Information',
      icon: 'fa-solid fa-users',
      rolekey: 'Evaulator_tablisttable_EvaluatorPaymentDetailsView',
      data: [
        {
          name: (item) => `See the following profile for payment info: ${item.TpEvaluatorLinkPaymentInformationSource}`,
          label: 'Source',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-center, h3',
          hidden: (item) =>
            !item.TpEvaluatorLinkPaymentInformationSource ||
            item.TpEvaluatorLinkPaymentInformationSource == item.TpEvaluatorLinkId,
        },
        { name: '-', label: '' },
        { name: '-message-', label: 'Payment Method', className: 'text-left' },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationPreferredPaymentMethod,
          label: 'Preferred method by shopper',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationTransactionMethod,
          label: 'Transaction method selected by finance',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: '-', label: '' },
        { name: '-message-', label: 'Bank Transfer', className: 'text-left' },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankAccountHoldersName,
          label: 'Name on Bank Account',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBank,
          label: 'Bank',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankBranch,
          label: 'Bank Branch',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankAcct,
          label: 'Bank Account',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationIban,
          label: 'IBAN',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationSwiftCode,
          label: 'SWIFT Code',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankAddress,
          label: 'Bank Address',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankCountry,
          label: 'Bank Country',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationIfsccode,
          label: 'IFSC Code',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankZip,
          label: 'Bank Zip',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBankCity,
          label: 'Bank City',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationClRutNumber,
          label: 'CL RUT Number',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrCpf,
          label: 'BR CPF',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrPis,
          label: 'BR PIS',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrPix,
          label: 'BR Pix',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationPayeeAddress,
          label: 'Payee Address',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrBankCode,
          label: 'BR Bank Code',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrAccountType,
          label: 'BR Account Type',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrBankBranchNum,
          label: 'BR Bank Branch Number',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationBrBankAcctNum,
          label: 'BR Bank Account Number',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        { name: '-message-', label: 'Wise', className: 'text-left' },
        {
          name: (item) =>
            item.TpEvaluatorLinkPaymentInformationWiseAccount == null
              ? ''
              : item.TpEvaluatorLinkPaymentInformationWiseAccount
              ? 'Yes'
              : 'No',
          label: 'Wise Account',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationWiseCurr,
          label: 'Wise Currency',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationWiseCurrCode,
          label: 'Wise Currency Code',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationWiseEmail,
          label: 'Wise Email',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        { name: '-', label: '' },
        { name: '-message-', label: 'Misc', className: 'text-left' },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationPaypalAddress,
          label: 'PayPal Address',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationPayoneerEmail,
          label: 'Payoneer Email',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationSgPayNow,
          label: 'SG PayNow',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationCnAliPay,
          label: 'CN AliPay',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
          hidden: (item) => TpEvaluatorLinkItem.isPrismIntl(item),
        },
        {
          name: (item) =>
            item.TpEvaluatorLinkPaymentInformationPaymentInformationReceived == null
              ? ''
              : item.TpEvaluatorLinkPaymentInformationPaymentInformationReceived
              ? 'Yes'
              : 'No',
          label: 'Payment Information Received',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => (
            <DateComponent value={item.TpEvaluatorLinkPaymentInformationPaymentInformationChangedOnUtc} />
          ),
          label: 'Payment Information Last Changed',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
        {
          name: (item) => item.TpEvaluatorLinkPaymentInformationId,
          label: 'TpEvaluatorLinkPaymentId',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-left',
        },
      ],
    },
  ];

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-list-check',
            roleKey: 'Evaulator_faicon_AssignmentsButton',
            text: 'Jobs',
            onClick: () => TpEvaluatorLinkItem.ListJobsFunction(item),
          },
        ]}
      />
    );
  }

  static ListJobsFunction(item) {
    return alert('Not implemented');
  }

  // The TpEvaluatorId the "TpEvaluator Profiles" tab was opened for, bound by TpEvaluatorLinkAdmin (domain
  // statics are the repo's convention for tab-scoped context, like ListJobsFunction above). The backend returns
  // the primary's own records together with those of the profiles linked under it (CD-5527); the Type column
  // tells them apart without a backend change.
  static primaryTpEvaluatorId = null;

  // "Master"/"Slave" are Prism's own terms for a shopper's main and duplicate accounts, and the users asked for
  // the column to use them so it matches what they see in Prism. Not our vocabulary (the rest of the feature says
  // primary/linked) — keep them unless the business asks for a change.
  // CD-5605: the Payment Information fields Prism Intl never fills are hidden on its profiles.
  static isPrismIntl(item) {
    return item.ThirdPartySource === 'PrismIntl';
  }

  static TypeTexts = { Master: 'Master', Slave: 'Slave' };

  static getTypeText(item) {
    const primaryTpEvaluatorId = TpEvaluatorLinkItem.primaryTpEvaluatorId;
    if (primaryTpEvaluatorId === null || primaryTpEvaluatorId === undefined || !item.TpEvaluatorId) {
      return '';
    }
    return Number(item.TpEvaluatorId) === Number(primaryTpEvaluatorId)
      ? TpEvaluatorLinkItem.TypeTexts.Master
      : TpEvaluatorLinkItem.TypeTexts.Slave;
  }

  // static selectedStatus() {
  //   return false;
  // }

  // static getSelectedCellHeader(item) {
  //   return (
  //     <div>
  //       <input
  //         type='checkbox'
  //         checked={TpEvaluatorItem.selectedStatus()}
  //         onChange={(e) => {
  //           TpEvaluatorItem.clickOnGlobalSelect(item, e.target.checked);
  //         }}
  //       />
  //     </div>
  //   );
  // }
  // static clickOnGlobalSelect(item, selected) {}

  // static clickOnSelect(item, selected) {}

  // static getSelectedCellContent(item) {
  //   return (
  //     <div className='text-center'>
  //       <input
  //         type='checkbox'
  //         checked={item.Selected}
  //         onChange={(e) => {
  //           TpEvaluatorItem.clickOnSelect(item, e.target.checked);
  //         }}
  //       />
  //     </div>
  //   );
  // }
}
